import { Component, OnInit, inject, input, signal } from '@angular/core';
import { RAuditInfo, RAuditQueryResponse } from 'app/records/audit.record';
import { AuditInfoService } from 'app/services/audit.information.service';
import { NgIf, NgFor, DatePipe, NgSwitch, NgSwitchCase, NgSwitchDefault, DecimalPipe } from '@angular/common';

@Component({
    selector: 'zf-audit-info',
    templateUrl: './audit-info.component.html',
    styleUrls: ['./audit-info.component.scss'],
    imports: [NgIf, NgFor, DatePipe, NgSwitch, NgSwitchCase, NgSwitchDefault, DecimalPipe]
})
export class AuditInfoComponent implements OnInit {
    private auditService = inject(AuditInfoService);

    public readonly accountId = input<number>();
    public readonly serialNumber = input<string>();

    public readonly audits = signal<Array<RAuditInfo>>(null);
    public readonly lastKey = signal<string>(null);
    public readonly loading = signal<boolean>(true);

    public ngOnInit(): void {
        this.auditService.getAudits(this.accountId(), this.serialNumber(), null).subscribe((auditResponse: RAuditQueryResponse) => {
            this.audits.set(auditResponse.items);
            this.lastKey.set(auditResponse.lastKey);
            this.loading.set(false);
        });
    }

    public moreRecords(event: MouseEvent) {
        event.stopPropagation();
        this.auditService.getAudits(this.accountId(), this.serialNumber(), this.lastKey()).subscribe((auditResponse: RAuditQueryResponse) => {
            this.audits.update((audits: Array<RAuditInfo>) => [...audits, ...auditResponse.items]);
            this.lastKey.set(auditResponse.lastKey);
            this.loading.set(false);
        });
    }
}
